export enum SupplierDashboardFilterBy {
	new = 'NEW',
	all = 'ALL',
	pinned = 'PINNED',
	closingToday = 'CLOSING_TODAY',
	openToBid = 'OPEN_TO_BID',
	participating = 'PARTICIPATING',
	notParticipated = 'NOT_PARTICIPATED',
	optedOut = 'OPTED_OUT',
	lost = 'LOST',
	won = 'WON',
	ended = 'ENDED',
	closed = 'CLOSED',
}
